module.exports = __webpack_public_path__ + "static/media/mysql.dd2dd2e8.png";